import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../shared/makeApiCall";

export type Carrier = {
  id: number;
  name: string;
};

export type CarrierOption = {
  value: number;
  label: string;
};

export const carriersApi = {
  list: (search = "", page = 1) =>
    makePostApiCall("carriers", { search, page }),
  dropdown: () => makeGetApiCall("carriers/dropdown"),
  create: (name: string) => makePostApiCall("carriers/create", { name }),
  update: (id: number, name: string) =>
    makePutApiCall(`carriers/${id}`, { name }),
};
